import React from 'react'
import DefineSections from './defineSections'
import ProductProfile, {OpenProductProfileForm} from './productProfile'
import ShapeProfile, {OpenShapeProfileForm} from './shapeProfile'
import Button from '../../../../../components/UiElements/Button'
import STLViewerComponent from '../../../../../components/Product3D/util/viewerHooks/internal/STLViewerComponent'
import {snapshot} from "valtio";
import store from "@/store";


const formView = (defaultValues, value) => {
    //console.log("defaultValues---->", defaultValues)
    const {companySetting} = snapshot(store)
    
    
    const saveCondition = (data)=> {
		/*console.log("saveCondition", data, (!data?.sectionsValidations || data?.sectionsValidations.length === 0) &&
			data?.objectFile &&
			data?.stlFile &&
			data?.product_profile &&
			data?.shape_profile &&
			data?.pricing &&
			data?.sections?.length > 0);*/
		
		
        if (companySetting.machine) {
            return (!data?.sectionsValidations || data?.sectionsValidations.length === 0) &&
                data?.objectFile &&
                data?.stlFile &&
                data?.product_profile &&
                data?.shape_profile &&
                data?.pricing &&
                data?.sections?.length > 0
        } else {
            return (!data?.sectionsValidations || data?.sectionsValidations.length === 0) &&
                data?.objectFile &&
                data?.pricing &&
                data?.sections?.length > 0
        }
    }
    
    let returnObject = [
        
        {
            name: 'product',
            type: 'Hidden',
            googleUpload: false,
            
        },
        {
            name: 'thumbnail_image_url',
            type: 'Hidden',
            googleUpload: false,
        },
        {
            label: 'Upload 3D Model',
            hint: 'Upload the appropriate 3D model to specify areas on it to designate for engraving designs.',
            type: 'Header',
            labelClassName: 'hidden',
        },
        {
            name: 'objectFile',
            label: `${value?.objectFile ? '3D Object' : 'Select 3D Object'}`,
            placeholder: 'Drag and drop your *.glb file here',
            type: 'File',
            accept: '.glb',
            className: `${value?.objectFile ? 'max-w-[600px]' : 'max-w-[600px] '}`,
            clear: true,
            reset: true,
            defaultValue: defaultValues?.objectFile || null,
            googleUpload: false,
            disabled: false,
        },
        {
            name: 'objectFile_url',
            type: 'Hidden',
            saveData: true,
        },
        {
            name: 'stlFile',
            label: `${value?.stlFile ? 'STL File' : 'Select STL File'}`,
            placeholder: 'Drag and drop your *.stl file here',
            type: 'File',
            accept: '.stl',
            className: `${value?.stlFile ? 'max-w-[600px]' : 'max-w-[600px] '}`,
            clear: true,
            reset: true,
            defaultValue: defaultValues?.stlFile || null,
        },
        {
            name: 'stlFile_url_preview',
            className: 'max-w-[600px]',
            type: 'Module',
            condition: (value) => value?.stlFile,
            module: () => {
                return <STLViewerComponent url={value?.stlFile}/>
                
                
            }
        },
        {
            name: 'stlFile_url',
            type: 'Hidden',
            defaultValue: defaultValues?.stlFile || null,
            googleUpload: false,
            saveData: true,
        },
        
        {
            name: 'divider',
            type: 'Divider',
            condition: (value) => value?.objectFile && value?.stlFile, //&& value?.product_profile && value?.shape_profile,
        },
        {
            label: 'Define Profiles',
            hint: 'Fill out the form to set your profile, or clone from another product for accurate engraving.',
            type: 'Header',
            labelClassName: 'hidden',
            condition: (value) => value?.objectFile && value?.stlFile, //&& value?.product_profile && value?.shape_profile,
        },
        {
            name: 'product_profile',
            label: 'Product Profile',
            type: 'PopUp',
            module: ProductProfile,
            view: OpenProductProfileForm,
            title: 'Product Profile',
            innerClassName: 'w-[900px]',
            condition: (value) => (value?.objectFile && value?.stlFile) || value?.product_profile,
            saveData: true,
            reset: false,
            clear: true,
            defaultValue: defaultValues?.product_profile,
        },
        {
            name: 'shape_profile',
            label: 'Shape Profile',
            type: 'PopUp',
            module: ShapeProfile,
            view: OpenShapeProfileForm,
            title: 'Shape Profile',
            innerClassName: 'w-[900px]',
            defaultValue: {
                ...defaultValues?.shape_profile,
                stl: value?.stlFile,
                glb: value?.objectFile,
            },
            saveData: true,
            reset: false,
            condition: (value) => (value?.objectFile && value?.stlFile) || value.shape_profile.name, //&& value?.product_profile,
        },
        {
            name: 'divider',
            type: 'Divider',
            condition: (value) => value?.objectFile && value?.stlFile && value?.product_profile && value?.shape_profile,
        },
        {
            label: 'Define Sections',
            hint: 'Specify areas on it to designate for engraving designs.',
            type: 'Header',
            labelClassName: 'hidden',
            condition: (value) => value?.objectFile && value?.stlFile && value?.product_profile && value?.shape_profile,
        },
        
        {
            name: 'sections',
            label: 'Define Sections',
            type: 'Module',
            module: DefineSections,
            labelClassName: 'hidden',
            defaultValue: defaultValues?.sections || [],
            condition: (value, change) => {
                const condition = !!value?.objectFile //&& value?.stlFile && value?.product_profile && value?.shape_profile
                if (Array.isArray(value?.sections)) {
                    const setSection = value?.sections?.map((section, index) => {
                        return {...section, _load: true}
                    })
                    if (JSON.stringify(setSection) !== JSON.stringify(value?.sections) && !condition) {
                        change(setSection, 'sections')
                    }
                }
                return condition
            },
            saveData: true,
        },
        {
            label: 'Define Price',
            hint: 'Fill out price from list.',
            type: 'Header',
            labelClassName: 'hidden',
            
        },
        {
            name: 'pricing',
            label: 'pricing',
            type: 'Select',
            list: value?.pricingList,
            labelClassName: 'hidden',
            className: 'max-w-[600px]',
            defaultValue: defaultValues?.pricing || null,
            menuPortalTarget: 'true',
            saveData: true,
        },
        {
            name: 'pricingList',
            type: 'Hidden',
            defaultValue: [],
        },
        {
            name: 'sectionsValidations',
            type: 'Module',
            module: ({item, bound, data, submit}) => {
                const condition =
                    (!data?.sectionsValidations || data?.sectionsValidations.length === 0) &&
                    data?.objectFile &&
                    data?.stlFile &&
                    data?.product_profile &&
                    data?.shape_profile &&
                    
                    data?.sections?.length > 0
                return (
                    <div
                        className={`fixed bottom-0 left-0 w-full h-[8px]  z-[70] shadow-box transition-all ${
                            condition ? 'bg-primary-500' : 'bg-red-500'
                        }`}
                    ></div>
                )
            },
            defaultValue: [],
            saveData: true,
        },
        
        
        {
            name: 'createUpdateProfile',
            label: 'Create',
            type: 'Module',
            module: ({item, bound, data, submit}) => {
                /*const condition =
                    (!data?.sectionsValidations || data?.sectionsValidations.length === 0) &&
                    data?.objectFile &&
                    data?.stlFile &&
                    data?.product_profile &&
                    data?.shape_profile &&
                    data?.pricing &&
                    data?.sections?.length > 0*/
                const condition = saveCondition(data)
                let update = !!data?.product?.product_profile_id
                return (
                    <div
                        className={` border-gray-300 rounded-xl p-lg py-xl flex flex-col gap-xxl ${
                            condition ? 'bg-primary-500' : 'bg-gray-300'
                        } text-white mt-xxl`}
                    >
                        <div className={' flex flex-col gap-xs'}>
                            <span
                                className={'text-title-xxl'}>{update ? 'Update' : 'Create'} Your Engraving Product</span>
                            <span className={'text-text-md'}>Finalize your design settings and make it available for engraving</span>
                        </div>
                        <Button
                            size={'lg'}
                            disabled={!condition}
                            onClick={() => {
                                
                                data?.createUpdateProfile()
                            }}
                            type={'alt'}
                            className={`w-[400px] border-0 ${condition ? 'hover:bg-primary-100' : ''}`}
                        >
                            {update ? 'Update Product' : 'Create Product'}
                        </Button>
                    </div>
                )
            },
            saveData: true,
            labelClassName: 'hidden',
            //condition: (value)=> (!value?.sectionsValidations || value?.sectionsValidations.length === 0) && value?.objectFile && value?.stlFile && value?.product_profile && value?.shape_profile && value?.sections?.length > 0,
        },
    ]
    
    if (!companySetting?.machine) {
        const removeArray = ["stlFile", "stlFile_url", "shape_profile", "product_profile"]

        returnObject.forEach((item, index) => {
            if (removeArray.includes(item.name)) {
                returnObject[index] = {...item, type: "Hidden"}
                //console.log("item", item, index)
            }
        })
        //returnObject = returnObject.filter(item => !removeArray.includes(item.name))
        
        //console.log("returnObject", returnObject)
    }
    
    return returnObject
}

export default formView
